import React, { Fragment } from "react";
import { ProductSaleItem, ProductTypes } from "../../../../logic/api";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const SaleItemBadges: React.FunctionComponent<{
  saleItems: ProductSaleItem[] | null;
}> = (props) => {

  const { t } = useTranslation();

  if (props.saleItems == null || props.saleItems.length == 0) {
    return <Fragment></Fragment>;
  }
  return (
    <div style={{ textAlign: "left", marginBottom: 20, zoom: 0.6 }}>
      {props.saleItems.map((item, key) => {
        if (item.voided == true) {
          return <Fragment key={key}></Fragment>;
        }

        let alias =
          item.productCode == null || item.productCode == ""
            ? ""
            : item.productCode;

        let colour = "#eee";

        if (item.productType == ProductTypes.valet) {
          colour = "orange";
          if (alias.length == 0) {
            alias = t("sale.alias.valet");
          }
        } else if (item.productType == ProductTypes.walkIn) {
          colour = "teal";
          if (alias.length == 0) {
            alias = t("sale.alias.walkIn");
          }
        } else if (item.productType == ProductTypes.collection) {
          colour = "blue";
          if (alias.length == 0) {
            alias = t("sale.alias.collection");
          }
        } else if (item.productType == ProductTypes.delivery) {
          colour = "brown";
          if (alias.length == 0) {
            alias = t("sale.alias.delivery");
          }
        } else if (item.productType == ProductTypes.electricVehicle) {
          colour = "green";
          if (alias.length == 0) {
            alias = t("sale.alias.ev");
          }
        } else {
          colour = "purple";
          if (alias.length == 0) {
            return <Fragment key={key}></Fragment>;
          }

        }

        if (alias.length == 0) {
          return <Fragment key={key}></Fragment>;
        }
        return (
          <div
            title={item.name}
            key={key}
            style={{
              paddingLeft: 7,
              paddingRight: 7,
              paddingBottom: 3,
              display: "inline-block",
              fontSize: "2rem",
              color: colour,
              border: `solid 2px ${colour}`,
              marginLeft: 10,
              borderRadius: 10,
            }}
          >
            <b>{alias}</b>
          </div>
        );
      })}
    </div>
  );
};

SaleItemBadges.propTypes = {
  saleItems: propTypes.any,
};

export default SaleItemBadges;
